<template>
  <b-container>
    <b-row align-h="center">
      <b-col cols="6">
        <b-card>
          <b-form v-on:submit.prevent>
            <b-form-group label="Warehouse" label-for="warehouse">
              <v-select
                id="warehouse"
                v-model="form.selectedWarehouse"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="text"
                :options="form.optionsWarehouse"
              >
                <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="!form.selectedWarehouse"
                    v-bind="attributes"
                    v-on="events"
                  />
                </template>
              </v-select>
              <!-- Selected: <strong>{{ form.selectedWarehouse }}</strong> -->
            </b-form-group>
            <b-form-group label="Code" label-for="code">
              <b-form-input
                id="code"
                placeholder="Code"
                v-model="form.code"
                required
              />
            </b-form-group>
            <b-form-group label="Name" label-for="name">
              <b-form-input
                id="name"
                placeholder="Name"
                v-model="form.name"
                required
              />
            </b-form-group>
            <b-form-group label="Capacity ( % )" label-for="capacity">
              <b-form-input
                id="capacity"
                placeholder="Capacity ( % )"
                v-model="form.capacity"
                type="number"
                max="100"
                onKeyPress="if(this.value.length==3) return false;"
                required
              />
            </b-form-group>
            <b-row>
              <b-col
                cols="6"
                class="mt-1"
                v-if="permissions.includes('warehouse-bin-update')"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="updateBinLocation()"
                  block
                >
                  Update
                </b-button>
              </b-col>
              <b-col
                class="mt-1"
                v-if="permissions.includes('warehouse-bin-delete')"
              >
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="danger"
                  class="mr-1"
                  @click="deleteBinLocation()"
                  block
                >
                  Delete
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BFormSelect,
  BListGroupItem,
  BAvatar,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import Prism from "vue-prism-component";
import "prismjs";
import "prismjs/themes/prism-tomorrow.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";

export default {
  components: {
    ToastificationContent,
    vSelect,
    BFormSelect,
    BListGroupItem,
    BAvatar,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    Prism,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      form: {
        selectedWarehouse: null,
        optionsWarehouse: [],
        code: "",
        name: "",
        capacity: null,
      },
      permissions: [],
      errors: "",
      errMessage: "",
    };
  },
  created() {
    this.getAllPermissions();
    this.getWarehouse();
    this.getDetails();
  },
  methods: {
    getAllPermissions() {
      this.permissions = sessionStorage.getItem("permissions");
    },
    getWarehouse() {
      this.$http.get("warehouses").then((response) => {
        // console.log(response.data.data)
        this.form.optionsWarehouse.push({
          value: null,
          text: "Select 1 Warehouse",
        });

        var datas = response.data.data;
        var i;
        for (i = 0; i < datas.length; i++) {
          var $data = {
            value: datas[i].id,
            text: datas[i].name,
          };
          // console.log($data)
          this.form.optionsWarehouse.push($data);
        }
        // console.log(this.form.optionsWarehouse)
      });
    },
    getDetails() {
      const id = this.$route.params.id;
      this.$http.get("warehouse/bin/" + id).then((response) => {
        // console.log(response.data.data)
        this.form.selectedWarehouse = {
          value: response.data.data.warehouse_id,
          text: response.data.data.warehouse_name,
        };
        this.form.code = response.data.data.code;
        this.form.name = response.data.data.name;
        this.form.capacity = response.data.data.capacity;
      });
    },
    updateBinLocation() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/bin/" + id + "/update", {
          warehouse_id: this.form.selectedWarehouse.value,
          code: this.form.code,
          name: this.form.name,
          capacity: this.form.capacity,
        })
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Success update Bin Location",
              variant: "success",
            },
          });
          location.href = "/warehouse/bin-location";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: this.errMessage,
              variant: "warning",
            },
          });
          console.log(errors.response);
        });
    },
    deleteBinLocation() {
      const id = this.$route.params.id;
      this.$http
        .post("warehouse/bin/" + id + "/delete")
        .then((response) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Notification",
              icon: "BellIcon",
              text: "Bin Location has been Deleted",
              variant: "danger",
            },
          });
          location.href = "/warehouse/bin-location";
          // console.log(response.data.data)
        })
        .catch((errors) => {
          this.errMessage = errors.response.data.message;
          console.log(errors.response);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>